import {
  Component,
  EventEmitter,
  OnInit,
  Input,
  Output,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
} from "@angular/core";
import { Subscription } from "rxjs";
import { EventManagerService } from "../../service/event-manager.service";
import { DateUtil } from "../../utils/date.util";
/**
 * declare Jquery
 * */
declare let $: any;

@Component({
  selector: "input-datepicker-and-time",
  templateUrl: "./input-datepicker-and-time.html",
  styleUrls: ["./input-datepicker-and-time.scss"],
})
export class InputDatePickerAndTimeComponent implements OnInit, OnChanges {
  @Input("placeholder") placeholder: string = 'Chọn ngày';
  @Input() data: any;
  @Input('isNoPast') isNoPast: boolean = false;
  @Input('isNoCurrentDate') isNoCurrentDate: boolean = false;
  @Input('isNoFuture') isNoFuture: boolean = false;
  @Output() dataChange = new EventEmitter<any>();
  @Output() result = new EventEmitter<any>();
  date: {day: any, hour: any, minute: any, time: any} = {day: null, hour: '00', minute: '00', time: ''};
  hours: any[] = [];
  minutes: any[] = [];
  isShowTime: boolean = false;
  subscriptions?: Subscription[] = [];
  id = 'inputDateTimePicker' + Math.floor(Math.random() * 1000) + Math.floor(Math.random() * 999);

  constructor(
    private eventManager: EventManagerService,
    private cdf: ChangeDetectorRef
  ) {}
  ngOnInit() {
    for (let i = 0; i <= 23; i++) {
      this.hours.push(i < 10 ? '0' + i : i +'');
    }
    for (let i = 0; i <= 59; i++) {
      this.minutes.push(i < 10 ? '0' + i : i +'');
    }
    this.setTime();
    this.subscriptions = [
      this.eventManager.subscribe('body-click', (res) => {
        const event = res.content.event;
        if ($(event.target).closest('#' + this.id).length === 0 && $(event.target).closest('#action' + this.id).length === 0) {
          this.isShowTime = false;
        } else {
          this.isShowTime = true;
        }
      }),
    ]
    
  }
  ngOnChanges(simpleChanges: SimpleChanges) {
    const changes: any  = simpleChanges;
    if (changes.data && changes.data.currentValue) {
      const date = new Date(changes.data.currentValue);
      this.setDate(date);
    }
  }
  setDate(date) {
    this.date.day = date.getTime();
    this.date.hour = date.getHours() >= 10 ? date.getHours() + '' : '0' + date.getHours();
    this.date.minute = date.getMinutes() >= 10 ? date.getMinutes() + '' : '0' + date.getMinutes();
    this.setTime();
    this.cdf.detectChanges();
  }
  checkHour() {
    return this.date.hour && parseInt(this.date.hour) < 24;
  }
  checkMinute() {
    return this.date.minute && parseInt(this.date.minute) < 60;
  }
  getDate() {
    if (!this.date.day) {
      return null;
    }
    if (!this.checkHour() || !this.checkMinute()) {
      return null;
    }
    let date = DateUtil.revertDate(this.date.day, 'dd/MM/yyyy');
    date.setHours(this.date.hour);
    date.setMinutes(this.date.minute);
    return date.getTime();
  }
  changeValue() {
    setTimeout(() => {
      this.dataChange.emit(this.getDate());
      this.result.emit(this.getDate());
    }, 10)
  }
  showTime() {
    this.isShowTime = true;
    this.scrollToHourMinute();
  }
  changeHour(hour) {
    this.date.hour = hour;
    this.setTime();
  }
  changeMinute(minute) {
    this.date.minute = minute;
    this.setTime();
  }
  setTime() {
    this.date.time = `${this.date.hour}:${this.date.minute}`;
    this.changeValue();
  }
  scrollToHourMinute() {
    setTimeout(() => {
      $(`#scrollHour-${this.date.hour}-${this.id}`)[0].scrollIntoView({ behavior: 'smooth' });
      $(`#scrollMinute-${this.date.minute}-${this.id}`)[0].scrollIntoView({ behavior: 'smooth' });
    }, 100)
  }
}
